import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import {Typography} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import {Checkbox} from '@finpay-development/shared-components';

export const SECTION_DEFS = [
  {key: 'header', title: 'Headers', isSelectable: false},
  {key: 'benefitDetails', title: 'Benefit Details', isSelectable: true},
  {key: 'carePlanDetails', title: 'Care Plan Details', isSelectable: true},
  {key: 'pfrDetails', title: 'PFR Details', isSelectable: true},
  {key: 'attestation', title: 'Attestation', isSelectable: true}
] as const;

export type SectionKey = typeof SECTION_DEFS[number]['key'];

export const SectionSelectionModal = ({
  setIsModalOpen,
  initialVisibleSections,
  onUpdateVisibleSections,
}: {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  initialVisibleSections: Record<SectionKey, boolean>
  onUpdateVisibleSections: (next: Record<SectionKey, boolean>) => void
}) => {
  const [draftVisibleSections, setDraftVisibleSections] = React.useState<Record<SectionKey, boolean>>(
      () => ({...initialVisibleSections}),
  );

  return (
      <div>
        <Dialog
            scroll="body"
            className="modal client-modal"
            open={true}
            fullWidth={true}
            maxWidth="md"
        >
          <DialogTitle id="form-dialog-title">
            <Grid item xs={12} px={1}>
              <Typography variant="h6">Select Sections</Typography>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <form>
              <Grid container spacing={2} className="px-2 pb-2">
                <Grid item xs={12}>
                  {
                    SECTION_DEFS
                    .filter(({isSelectable}) => {
                      return isSelectable
                    })
                    .map(({key, title}) => {
                        return (
                            <Checkbox
                                key={key}
                                id={key}
                                name={key}
                                label={title}
                                checked={Boolean(draftVisibleSections[key])}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                  const checked = e.target.checked;
                                  setDraftVisibleSections((prev) => ({
                                    ...prev,
                                    [key]: checked,
                                  }));
                                }}
                            />
                        );
                    })
                  }
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <Grid container item spacing={2} justifyContent="flex-end"
                  alignItems="center">
              <Grid item>
                <Button
                    className="doc-modal"
                    onClick={() => setIsModalOpen(false)}
                    color="primary"
                    variant="contained"
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                    className="doc-modal"
                    onClick={() => {
                      onUpdateVisibleSections(draftVisibleSections);
                      setIsModalOpen(false);
                    }}
                    color="primary"
                    variant="contained"
                >
                  Select
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
  );
};